export default {
	hookPrefix: 'content-toggle-item',
};
